<template>
  <div id="app">
    <router-view />
    <Tabbar v-if="$route.meta.TabbarShow"></Tabbar>
  </div>
</template>

<script>
import Tabbar from './components/Tabbar'

export default {
  name: 'App',
  components: {
    Tabbar
  },
  data() {
    return {}
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  background-color: #F5F5F5;
  /* background-color: #FFFFFF; */
  height: 100vh;
}
:root {
  --bg: #f5f7fb;
  --card: #ffffff;
  --primary: linear-gradient(90deg, #0066ff, #00a0ff);
  --accent: #00a0ff;
  --text: #111827;
  --muted: #6b7280;
  --tips: #ff5050;
  --radius-lg: 8px;
  --radius-sm: 4px;
  --shadow-sm: 0 6px 18px rgba(15, 23, 42, 0.06);
  --shadow-xs: 0 2px 8px rgba(15, 23, 42, 0.04);
  --glass: rgba(255, 255, 255, 0.6);
}

.van-toast--text {
  max-width: 90vw !important;
  width: max-content !important;
  white-space: nowrap !important;
  padding: 10px 18px !important;
  border-radius: 999px !important;
}

</style>
